// addEditCandidateDetails

import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post, postFormData } from ".";

export const _handleCandidateDetailsSubmit = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.addEditCandidateDetails,
    data: data,
  };
  return await post(request);
};

export const _fetchCandidateDetails = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getCandidateDetails,
    data: data,
  };
  return await post(request);
};

export const _fetchCandidateDocuments = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getCandidateDocuments,
    data: data,
  };
  return await post(request);
};

export const _updateCandidatePaymentDetails = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.updateCandidatePaymentDetails,
    data: data,
  };
  return await post(request);
};

export const _updateCandidateDocuments = async (data) => {
  let formData = new FormData();
  formData.append("candidate_id", data.candidate_id);
  formData.append("compliance_id", data.compliance_id);
  formData.append("compliance_status", data.compliance_status);
  formData.append("not_applicable", data.not_applicable);
  formData.append("expirydate", data.expirydate);
  formData.append("compliance_file", data?.compliance_file);
  // extracompliance_file extracompliance_file1
  formData.append("extracompliance_file", data?.extracompliance_file);
  formData.append("extracompliance_file1", data?.extracompliance_file1);

  formData.append("extra_attachment_id", data?.extra_attachment_id);
  formData.append("extra_attachment_id1", data?.extra_attachment_id1);

  return postFormData(
    serviceRouteConstants?.uploadCandidateDocuments,
    formData,
  );
};
